import { IAppLazyWidget } from 'core-components/sitebuilder/models/IWidgetSelector'

export const lazyWidgets: IAppLazyWidget[] = [
  {
    key: 'AmplifyImpactWidgetSelector',
    loader: () => import('amplifyImpact/WidgetSelector'),
  },
  {
    key: 'CheckEngineWidgetSelector',
    loader: () => import('checkEngine/WidgetSelector'),
  },
  {
    key: 'HMSWidgetSelector',
    loader: () => import('hms/WidgetSelector'),
  },
  {
    key: 'KbaseWidgetSelector',
    loader: () => import('remoteKbase/WidgetSelector'),
  },
  {
    key: 'DocflowWidgetSelector',
    loader: () => import('remoteDocflow/WidgetSelector'),
  },
]
